export default {
  labels: {
    sold_out: '¡Agotado!',
    most_popular: '#{{rank}} Más popular',
    last_ordered: 'Último pedido',
  },
};
